import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import fdnRatings from "../../../../src/data/articles/cube-prospective-foundations/fdn-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  fdnRatings,
  ProspectiveIntro,
  React
};